import { Button } from 'src/shared/components/ui/buttons/button'
import { CONSTANTS } from 'src/shared/constants/constants'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { cn } from 'src/shared/utils/cn'

function ScheduleDemoButtonContent({ theme = 'dark', onClick }: { theme?: 'light' | 'dark'; onClick: () => void }) {
  const { isMobile } = useBreakpoint()

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        'h-[35px] min-h-0 flex-shrink-0 rounded-full border border-primary px-2 text-[12px] font-medium xs:px-3 xs:text-[14px]',
        theme === 'light' && 'border-white text-white hover:text-white',
        isMobile && 'h-[30px] w-[110px]',
      )}
      onClick={onClick}
    >
      Schedule demo
    </Button>
  )
}

interface ScheduleDemoButtonProps {
  theme?: 'light' | 'dark'
  variant?: 'professional' | 'enterprise'
}

export default function ScheduleDemoButton({ theme = 'dark', variant = 'enterprise' }: ScheduleDemoButtonProps) {
  const onClick = () => {
    if (variant === 'professional') {
      window.open(CONSTANTS.LINK_TO_DEMO_FOR_PROFESSIONALS, '_blank')
    } else if (variant === 'enterprise') {
      window.open(CONSTANTS.LINK_TO_DEMO_FOR_ENTERPRISES, '_blank')
    }
  }

  return <ScheduleDemoButtonContent theme={theme} onClick={onClick} />
}
